<div
  #rootElement
  class="studio-color-input"
  [class.is-open]="showPresetMenu"
  (focusout)="handleFocusOut($event)"
>
  <div class="studio-color-input__group">
    <div class="studio-color-input__field-shell">
      <input
        #valueInput
        class="studio-color-input__field"
        type="text"
        [value]="displayValue"
        [placeholder]="inputPlaceholder"
        (input)="handleInput(valueInput.value)"
        (keydown)="handleFieldKeydown($event)"
        (click)="openPresetMenu()"
      />
    </div>

    <button
      #pickerButton
      type="button"
      class="studio-color-input__picker-button"
      aria-label="Open color picker"
      (click)="openPicker()"
    >
      <span class="studio-color-input__swatch-shell" [class.is-transparent]="isTransparentValue(draftValue)">
        <span class="studio-color-input__swatch" [style.background]="swatchBackground"></span>
      </span>
    </button>

    <input
      #pickerInput
      class="studio-color-input__picker-input"
      type="color"
      [value]="pickerValue"
      (input)="applyPickerValue(pickerInput.value)"
    />
  </div>

  @if (showPresetMenu) {
    <div
      #presetMenu
      class="studio-color-input__menu bw-dropdown-scroll"
      role="listbox"
      aria-label="Color presets"
    >
      @for (section of config.sections; track section.id) {
        <div class="studio-color-input__section">
          <p class="studio-color-input__heading">{{ section.label }}</p>
          <div class="studio-color-input__list">
            @for (preset of section.presets; track preset.value) {
              <button
                type="button"
                class="studio-color-input__option"
                [class.is-active]="isPresetActive(preset)"
                (click)="selectPreset(preset)"
              >
                <span class="studio-color-input__option-swatch-shell" [class.is-transparent]="isTransparentValue(preset.value)">
                  <span class="studio-color-input__option-swatch" [style.background]="preset.value"></span>
                </span>
                <span class="studio-color-input__option-label">{{ preset.label }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
